import { useMemo } from 'react'
import { Contract } from '@ethersproject/contracts'
import { useActiveWeb3React } from './'
import { getContract } from '../utils'
import ERC20_ABI from '../abis/erc20.json'
import { ERC20_BYTES32_ABI } from '../abis/erc20'
import SANDCLOCK_VESTED_REWARDS_ABI from '../abis/vested-rewards.json'
import SANDCLOCK_PHASE_ONE_ABI from '../abis/phase-one.json'

function useContract(address: string | undefined, ABI: any, withSignerIfPossible = true): Contract | null {
  const { library, account } = useActiveWeb3React()

  return useMemo(() => {
    if (!address || !ABI || !library) return null
    try {
      return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined)
    } catch (error) {
      console.error('Failed to get contract', error)
      return null
    }
  }, [address, ABI, library, withSignerIfPossible, account])
}

export function useTokenContract(tokenAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(tokenAddress, ERC20_ABI, withSignerIfPossible)
}

export function useBytes32TokenContract(tokenAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(tokenAddress, ERC20_BYTES32_ABI, withSignerIfPossible)
}

export function useRewardsContract(contractAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(contractAddress, SANDCLOCK_VESTED_REWARDS_ABI, withSignerIfPossible)
}

export function usePhaseOneContract(contractAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(contractAddress, SANDCLOCK_PHASE_ONE_ABI, withSignerIfPossible)
}
